export class IotError extends Error {
    constructor(public override message: string) {
        super(message);
        Object.setPrototypeOf(this, IotError.prototype);
    }
}
